export default __webpack_public_path__ + "images/0xb5b060055f0d1ef5174329913ef861bc3addf029.png";